var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"content mx-4",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.clicked}})])
}
var staticRenderFns = []

export { render, staticRenderFns }